import type { Component } from 'vue'
import { createApp } from 'vue'

import { registerComponents } from '/@front:shared/components'
import { registerPlugins } from '/@front:shared/plugins'
import { registerTelInput } from '/@front:shared/plugins/tel-input'

export function mountPage(page: Component, { telInput = false, el = '#main-content' } = {}) {
  const app = createApp(page)

  registerComponents(app)
  registerPlugins(app)

  if (telInput) {
    registerTelInput(app)
  }

  app.mount(el)
}
